import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { mdiAlertCircle } from '@mdi/js';
import Icon from '@mdi/react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { updateOverAllRating } from '../../../../store/apis/calibrationService';
import { getAuthUser } from '../../../../utils/auth.util';

function ReleaseCalibrationModal({
  isOpen,
  toggle,
  sessionIds,
  refetchCalibrationDetails,
}) {
  const { id } = getAuthUser();

  // Release result function
  const { mutate: updateRating, isPending } = useMutation({
    mutationFn: updateOverAllRating,
    onSuccess: () => {
      toast.success('Calibration released successfully!', {
        className: 'toast-success',
      });
      toggle();
      refetchCalibrationDetails();
    },
    onError: error => {
      toast.error(error?.message || 'Failed to release Calibration', {
        className: 'toast-error',
      });
      toggle();
    },
  });

  const onRelease = () => {
    const payload = {
      sessionId: -1,
      userId: id,
      status: 'Released',
      sessionIds,
    };
    updateRating(payload);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      modalClassName="custom-modal-size"
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader toggle={toggle}>
        <div style={{ color: 'red' }} className="fs-6">
          <Icon path={mdiAlertCircle} size={0.8} /> Confirm Submission
        </div>
      </ModalHeader>
      <ModalBody>
        You are about to Release Ratings for all Employees. Are you sure you
        want to Proceed further?
      </ModalBody>
      <ModalFooter className="modalFooter">
        <Button className="item custom-light-btn" onClick={toggle}>
          No
        </Button>
        <Button
          className="item custom-btn"
          onClick={() => {
            onRelease();
          }}
          disabled={isPending}
          isLoading={isPending}
          loadingText="Releasing..."
        >
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ReleaseCalibrationModal;
